const config = require('../../../../config');
// 这边不要改动，改动须在/config/index.js里dev.isAliServer进行!!!
// export const BASE_URL = config.dev.isAliServer ?  'http://192.168.1.222:8081/gys_users_req' : '/gys_users_req'
// export const BASE_URL = config.dev.isAliServer ? 'http://106.15.250.223/gys_users_req' : '/gys_use/rs_req'
// export const BASE_URL = config.dev.isAliServer ?  'http://192.168.1.225/gys_users_req' : '/gys_users_req'
// export const BASE_URL = config.dev.isAliServer ? 'https://service.linkda.com.cn/gys_users_req' : '/gys_users_req'
// export const BASE_URL = config.dev.isAliServer ? 'https://service1.mckintey.top/gys_users_req' : '/gys_users_req'; // 64
// export const BASE_URL = config.dev.isAliServer ? 'http://101.132.129.64/gys_users_req' : '/gys_users_req'   //64
// export const BASE_URL = config.dev.isAliServer ?  'http://47.100.231.174/gys_users_req' : '/gys_users_req'   //64

// export const BASE_URL = '/gys_users_req'
// 20220601改动:开发时打开上面的，上线时打开下面的
export const BASE_URL =  config.dev.isAliServer ?`${window.location.origin}/gys_users_req`:'/gys_users_req'


// WEBPACK FOOTER //
// ./src/assets/common/base/config.js